const holder = {
  closePrivacySelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter('isOpen', false);
      document.removeEventListener("mousedown", holder.closePrivacySelector)
    }
  }
};

export default {
  'PrivacyDropdown.HeaderWrapper': ({ isOpen, dropdownRef }, _, internalStateSetter) => {
    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = dropdownRef;
    internalStateSetter('isOpen', !isOpen);
    if (isOpen) {
      document.removeEventListener("mousedown", holder.closePrivacySelector);
    } else {
      document.addEventListener("mousedown", holder.closePrivacySelector);
    }
  },

  'PrivacyDropdown.Body.Public': ({ }, outlet, internalStateSetter) => {
    outlet({ privacy: 'Public' });
    internalStateSetter('isOpen', false);
  },

  'PrivacyDropdown.Body.Private': ({ }, outlet, internalStateSetter) => {
    outlet({ privacy: 'Private' });
    internalStateSetter('isOpen', false);
  },
}